import type { ReactNode } from "react";

type MetricCardProps = {
  label: string;
  value: string;
  detail?: string;
  icon?: ReactNode;
  tone?: "green" | "gold" | "teal" | "clay";
};

export default function MetricCard({ label, value, detail, icon, tone = "green" }: MetricCardProps) {
  return (
    <div className={`metric-card tone-${tone}`}>
      <div>
        <p>{label}</p>
        <strong>{value}</strong>
        {detail ? <span>{detail}</span> : null}
      </div>
      {icon ? <div className="metric-icon">{icon}</div> : null}
    </div>
  );
}
